import { createSelector } from '@reduxjs/toolkit';

import { FrameDataType } from '@/modules/types/frame';
import { ElearningDataType } from '@/modules/types/elearning';
import { getAssetLocation, getCKFileName } from '@/lib/util';

const selectElearning = (state: any) => state.elearningData;
const selectFrame = (state: any) => state.frameData;
const selectMode = (state: any) => state.mode;
const selectCurrentFrameId = (state: any) => state.currentFrameId;

interface FrameNavSelectorType {
  currentFrameId: string | undefined;
  nextFrameId: string;
  prevFrameId: string;
  total: number;
  currentFramePage: number;
}

export const frameNavSelector = createSelector(
  selectFrame,
  selectCurrentFrameId,
  (frames: FrameDataType[], currentFrameId: string) => {
    const returnData: FrameNavSelectorType = {
      currentFrameId,
      nextFrameId: '',
      prevFrameId: '',
      total: 0,
      currentFramePage: 0,
    };
    let currentFrameIndex = 0;
    if (frames && frames.length > 0) {
      returnData.currentFrameId =
        currentFrameId !== undefined ? currentFrameId : frames[0].id;
      const frameIds: string[] = [];
      frames.forEach((item, index) => {
        if (currentFrameId === item.id) {
          currentFrameIndex = index;
        }
        frameIds.push(item.id);
      });

      returnData.total = frameIds.length;
      returnData.currentFramePage = currentFrameIndex + 1;

      if (currentFrameIndex > 0) {
        returnData.prevFrameId = frameIds[currentFrameIndex - 1];
      }

      if (currentFrameIndex < frameIds.length - 1) {
        returnData.nextFrameId = frameIds[currentFrameIndex + 1];
      }
    }
    return returnData;
  },
);

export const currentFrameDataSelector = createSelector(
  selectElearning,
  selectFrame,
  selectCurrentFrameId,
  selectMode,
  (
    elearningData: ElearningDataType,
    frames: FrameDataType[],
    currentFrameId: string,
    mode: string,
  ) => {
    let frameData: FrameDataType | undefined;
    if (frames && frames.length > 0) {
      // @todo: check Ken's comment https://bitbucket.org/elmodevelopment/elmo-sandcastle-fe/pull-requests/314#comment-360313727
      // set current FrameData to first
      frameData =
        (currentFrameId &&
          frames?.find((frameElement) => frameElement.id === currentFrameId)) ||
        frames[0];

      if (frameData) {
        let frameContent = frameData.content;
        const frameScript = frameContent?.match(
          /<script(.*?)<\/script>/gs,
        ) as string[];

        if (mode !== 'canvas') {
          frameContent = frameContent?.replace(/<script(.*?)<\/script>/gs, '');
          frameContent = frameContent?.replace(/href="#"/g, '');
        }

        return {
          ...frameData,
          ...{ content: frameContent },
          ...{
            frameMetadata: { ...frameData.frameMetadata },
          },
          ...{ frameScript },
          elearningId: elearningData.id,
        };
      }
    }
    return frameData;
  },
);

export default currentFrameDataSelector;
